'use strict';

const _ = require('underscore');
const ActionCreateService = require('process/app/service/action/create');
const ActionUpdateService = require('process/app/service/action/update');
const ProjectMemberSearchView = require('common/ui/view/project/member-search');
const ActionStateEdit = require('process/ui/view/action/state-edit');
const ActionDateEdit = require('process/ui/view/action/date-edit');
const AssigneeEditTemplate = require('process/ui/template/action/assignee-edit.hbs');
const Template = require('process/ui/template/action/setting.hbs');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const Dialog = require('common/util/dialog');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
require('backbone.stickit');
require('backbone-validation');

const AssigneeEditItem = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: AssigneeEditTemplate,
    triggers: {
        'click .remove': 'remove'
    },

    templateContext: function() {
        const project = this.getOption('project');
        const member = project.getMembers().getMemberByUser(this.model);

        // アクション担当者になった後に、プロジェクトメンバーから外れた場合を雑に考慮する
        if (!member) {
            return {};
        }

        return {
            role: i18n.t(`base:project-role.${member.getRole()}`),
        };
    }
});

const AssigneeList = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: AssigneeEditItem,

    childViewOptions: function() {
        return {
            project: this.getOption('project')
        }
    },

    onChildviewRemove: function(child) {
        this.trigger('remove:member');
        this.triggerMethod('remove', child);
    },
});

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        saveButton: '.save',
        cancelButton: '.cancel',
        closeButton: '.close',
        selfAssign: '.assign-self'
    },
    events: {
        'click @ui.saveButton': 'save',
        'click @ui.cancelButton': 'destroy',
        'click @ui.closeButton': 'destroy',
        'click @ui.selfAssign': 'selfAssign'
    },
    modelEvents: {
        'change:name': 'uploadable',
        'change:description': 'uploadable'
    },
    childViewEvents: {
        'select:member': 'uploadable',
        'remove:member': 'uploadable',
        'change:actionState': 'uploadable',
        'change:actionDate': 'uploadable'
    },
    regions: {
        state: '.state-edit-wrapper',
        date: '.date-edit-wrapper',
        assignees: '.assignees',
        assigneeSearch: '.assignee-search',
        writer: '.description-writer'
    },
    childViewTriggers: {
        insert: 'insert'
    },
    bindings: {
        '.name input': 'name'
    },

    initialize: function() {
        this._original = this.model;
        this.model = this.model.clone();
        this._assignees = new Backbone.Collection();
        this._assignees.add(this.model.getAssignees());
    },

    onRender: function() {
        this.$('form').submit(this.save);
        this.$('.modal').on('shown.bs.modal', function() {
            $(this).find('input[type=text]:first').focus();
        });

        const project = this.getOption('project');

        this.showChildView('state', new ActionStateEdit({
            model: this.model
        }));
        this.showChildView('date', new ActionDateEdit({
            model: this.model,
            project: project
        }));

        const writer = new MarkdownWriterView({
            project: this.model.getProject(),
            markdown: this.model.get('description'),
            // 新規作成時はまだ Action がサーバー側に存在しないため、
            // 添付ファイル付加時に Work を設定できない。
            // そのため、渡された Model に ID がある場合 = 新規作成時は
            // useContentSelector を false に設定する。
            useDataContentSelector: this._original.id ? true : false
        });
        this.showChildView('writer', writer);
        this.listenTo(writer, 'change', function(desc){
            this.model.set('description', desc);
        });

        Backbone.Validation.bind(this, {
            selector: 'class'
        });

        this.showChildView('assignees', new AssigneeList({
            collection: this._assignees,
            project: project
        }));

        this.stickit();

        this.showChildView('assigneeSearch', new ProjectMemberSearchView({
            project: project,
            exclude: (member) => {
                return this._assignees.contains(member.getUser());
            }
        }));
        this.getChildView('assigneeSearch').on('select', member => {
            this.assign(member.getUser());
        });

        return this;
    },

    onChildviewRemove: function(child) {
        this._assignees.remove(child.model);
    },

    save: function() {
        return new Promise((resolve, reject) => {
            const context = this.getOption('context');
            const currentUser = context.getUser();
            const currentUserGroupRole = context.getGroupRole().id;
            const currentUserProjectRole = context.getProjectRole().get('id');

            const isGroupAdmin = currentUserGroupRole === 'admin';
            const isProjectOwner = currentUserProjectRole === 'owner';
            const isAssigned = this._assignees.contains(currentUser);

            if (isGroupAdmin || isProjectOwner || isAssigned) {
                this.updateAction().then(resolve, reject);
            } else {
                Dialog.confirm({
                    text: i18n.t('notify.make_uneditable_action'),
                    okCallback: () => {
                        this.updateAction().then(resolve, reject);
                    },
                    cancelCallback: () => {
                        reject();
                    }
                });
            }
        });
    },

    updateAction: function() {
        return new Promise((resolve, reject) => {
            if(!this.model.isValid(true)) {
                return;
            }
            const actionDateEdit = this.getChildView('date');
            if(!actionDateEdit.validate()) {
                return;
            }

            const project = this.getOption('project');
            const actionDateJSON = actionDateEdit.getJSON();
            let promise = null;
            if(this.model.id) {
                const actionStateEdit = this.getChildView('state');
                if (!actionStateEdit.validate()) {
                    return;
                }
                const actionStateJSON = actionStateEdit.getJSON();
                this.model.setAssignees(this._assignees);
                let json = this.model.toJSON();
                json.state = actionStateJSON.state;
                json.startAt = actionDateJSON.startAt;
                json.endAt = actionDateJSON.endAt;
                promise = (new ActionUpdateService(
                    project, this.model.id, json
                )).update();
            } else {
                const json = {
                    name: this.model.get('name'),
                    description: this.model.get('description'),
                    assignees: this._assignees.map(a=> a.id),
                    kind: 'action',
                    point: {x: 0, y: 0},
                    parent: this.getOption('parent').id,
                    startAt: actionDateJSON.startAt,
                    endAt: actionDateJSON.endAt
                };
                promise = (new ActionCreateService(
                    project, json
                )).create();
            }

            promise.then(resolve, reject);
        });
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    assign: function(user) {
        this._assignees.add(user);
        setTimeout(() => {
            this.$('.assignee input').blur();
        }, 1);
        return '';
    },

    selfAssign: function() {
        const context = this.getOption('context');
        const currentUser = context.getUser();
        this.assign(currentUser);
        this.uploadable();
    }
});



// WEBPACK FOOTER //
// ./process/ui/view/action/setting.js